export default "__VITE_PUBLIC_ASSET__c2f6284e__"